
export const StaticSetting = {
    countDownTimer: 120
}